const AJUDA_LAST_UPDATED = "2026-08-24";

const HELP_SECTIONS = [
  { id: "mapa", icon: "map-pin", titleKey: "ajudaMapaTitle", bodyKey: "ajudaMapaBody", bullets: ["ajudaMapaB1", "ajudaMapaB2", "ajudaMapaB3", "ajudaMapaB4", "ajudaMapaB5", "ajudaMapaB6", "ajudaMapaB7", "ajudaMapaB8"] },
  { id: "reportar", icon: "megaphone", titleKey: "ajudaReportarTitle", bodyKey: "ajudaReportarBody", bullets: ["ajudaReportarB1", "ajudaReportarB2", "ajudaReportarB3", "ajudaReportarB4"] },
  { id: "rota", icon: "navigation", titleKey: "ajudaRotaTitle", bodyKey: "ajudaRotaBody", bullets: ["ajudaRotaB1", "ajudaRotaB2", "ajudaRotaB3", "ajudaRotaB4"] },
  { id: "noticias", icon: "newspaper", titleKey: "ajudaNoticiasTitle", bodyKey: "ajudaNoticiasBody", bullets: ["ajudaNoticiasB1", "ajudaNoticiasB2", "ajudaNoticiasB3"] },
  { id: "emergencia", icon: "siren", titleKey: "ajudaEmergenciaTitle", bodyKey: "ajudaEmergenciaBody", bullets: ["ajudaEmergenciaB1", "ajudaEmergenciaB2", "ajudaEmergenciaB3"] },
  { id: "alertas", icon: "shield", titleKey: "ajudaAlertasTitle", bodyKey: "ajudaAlertasBody", bullets: ["ajudaAlertasB1", "ajudaAlertasB2", "ajudaAlertasB3", "ajudaAlertasB4", "ajudaAlertasB5"] },
  { id: "meubairro", icon: "map", titleKey: "ajudaBairroTitle", bodyKey: "ajudaBairroBody", bullets: ["ajudaBairroB1", "ajudaBairroB2", "ajudaBairroB3", "ajudaBairroB4"] },
  { id: "comunidades", icon: "users", titleKey: "ajudaComunidadesTitle", bodyKey: "ajudaComunidadesBody", bullets: ["ajudaComunidadesB1", "ajudaComunidadesB2", "ajudaComunidadesB3", "ajudaComunidadesB4", "ajudaComunidadesB5", "ajudaComunidadesB6", "ajudaComunidadesB7", "ajudaComunidadesB8", "ajudaComunidadesB9", "ajudaComunidadesB10", "ajudaComunidadesB11", "ajudaComunidadesB12"] },
  { id: "perfil", icon: "user", titleKey: "ajudaPerfilTitle", bodyKey: "ajudaPerfilBody", bullets: ["ajudaPerfilB1", "ajudaPerfilB2", "ajudaPerfilB3", "ajudaPerfilB4", "ajudaPerfilB6", "ajudaPerfilB5", "ajudaPerfilB7", "ajudaPerfilB8"] },
  { id: "cabecalho", icon: "menu", titleKey: "ajudaHeaderTitle", bodyKey: "ajudaHeaderBody", bullets: ["ajudaHeaderB1", "ajudaHeaderB2", "ajudaHeaderB3"] },
];

function formatUpdatedDate(lang) {
  const d = new Date(AJUDA_LAST_UPDATED + "T00:00:00");
  const locale = lang === "en" ? "en-US" : lang === "es" ? "es-ES" : "pt-BR";
  return d.toLocaleDateString(locale, { day: "numeric", month: "long", year: "numeric" });
}

function AjudaScreen({ lang }) {
  const { Icon } = window.VigiALDesignSystem_ff2dec;
  const [openId, setOpenId] = React.useState(HELP_SECTIONS[0].id);

  return (
    <div style={{ padding: 14, flex: 1, overflowY: "auto" }}>
      <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)", marginBottom: 4 }}>{t(lang, "ajudaIntro")}</div>
      <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)", marginBottom: 12, fontFamily: "var(--font-mono)" }}>
        {t(lang, "ajudaUpdatedLabel")} {formatUpdatedDate(lang)}
      </div>

      {HELP_SECTIONS.map((section) => {
        const open = openId === section.id;
        return (
          <div key={section.id} style={{ border: "1px solid var(--color-border)", borderRadius: "var(--radius-lg)", overflow: "hidden", marginBottom: 8 }}>
            <button
              onClick={() => setOpenId(open ? null : section.id)}
              style={{
                width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10,
                padding: "11px 12px", background: "transparent", border: "none", cursor: "pointer", fontFamily: "var(--font-body)", textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 9, minWidth: 0 }}>
                <Icon name={section.icon} size={16} color={open ? "var(--color-brand-primary)" : "var(--color-text-secondary)"} />
                <span style={{ fontSize: "var(--text-sm)", fontWeight: 600, color: "var(--color-text-primary)" }}>{t(lang, section.titleKey)}</span>
              </div>
              <Icon name="chevron-down" size={14} color="var(--color-text-muted)" style={{ transform: open ? "rotate(180deg)" : "none", transition: "transform 0.15s", flexShrink: 0 }} />
            </button>
            {open && (
              <div style={{ padding: "0 14px 14px 37px" }}>
                <div style={{ fontSize: "var(--text-sm)", color: "var(--color-text-secondary)", marginBottom: 8 }}>{t(lang, section.bodyKey)}</div>
                <ul style={{ margin: 0, paddingLeft: 16, fontSize: "var(--text-xs)", color: "var(--color-text-secondary)" }}>
                  {section.bullets.map((key) => (
                    <li key={key} style={{ marginBottom: 6 }}>{t(lang, key)}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        );
      })}

      <div style={{ border: "1px solid var(--color-border)", borderRadius: "var(--radius-lg)", padding: 12, marginTop: 4 }}>
        <div style={{ fontSize: "var(--text-sm)", fontWeight: 600, color: "var(--color-text-primary)", marginBottom: 4 }}>{t(lang, "ajudaContactTitle")}</div>
        <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-secondary)", marginBottom: 8 }}>{t(lang, "ajudaContactBody")}</div>
        <a href="mailto:suporte@alertaal.com.br" style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: "var(--text-sm)", fontWeight: 600, color: "var(--color-brand-primary)", textDecoration: "none" }}>
          <Icon name="mail" size={14} color="var(--color-brand-primary)" /> suporte@alertaal.com.br
        </a>
        <div style={{ display: "flex", gap: 14, marginTop: 10 }}>
          <a href="termos.html" target="_blank" rel="noreferrer" style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)" }}>{t(lang, "ajudaTermsLink")}</a>
          <a href="privacidade.html" target="_blank" rel="noreferrer" style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)" }}>{t(lang, "ajudaPrivacyLink")}</a>
        </div>
      </div>
    </div>
  );
}
window.AjudaScreen = AjudaScreen;
